// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieNotice_wrapper__Hgpxh","actions":"CookieNotice_actions__xAkP-"};